function updateEventParam(el, clickEvs) {
    el.clickEvs = clickEvs
        ? Array.isArray(clickEvs)
            ? clickEvs
            : [clickEvs]
        : undefined;
}

function isClickTarget(targetEl, selector, rootEl) {
    if (targetEl === rootEl) {
        return false;
    }
    const closetSelectorEl = targetEl.closest(selector);
    if (!closetSelectorEl) {
        return false;
    }
    return rootEl.contains(closetSelectorEl);
}

var directive = {
    bind(el, binding) {
        updateEventParam(el, binding.value);
        if (!el.clickEvs) {
            return;
        }
        el.clickCb = function (event) {
            for (let i = 0; i < el.clickEvs.length; i++) {
                const { selector, callback, modifier } = el.clickEvs[i];
                if (!isClickTarget(event.target, selector, el) || !callback) {
                    continue;
                }
                if (modifier?.prevent) {
                    event.preventDefault();
                }
                if (modifier?.stop) {
                    event.stopPropagation();
                }
                callback({ event });
                break;
            }
        };
        el.addEventListener('click', el.clickCb, false);
    },
    update(el, binding) {
        directive.unbind(el);
        directive.bind(el, binding);
    },
    unbind(el) {
        if (el.clickCb) {
            el.removeEventListener('click', el.clickCb);
        }
    }
};
/**
 * 在dom上控制子节点的click事件注册
 * v-click="{ selector: '.selector', callback: func }"
 * v-click="[{ selector: '.selector1', callback: func1 }, { selector: '.selector2', callback: func2}]"
 */
export default function (Vue) {
    Vue.directive('click', directive);
}
